import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import OfflineDataService, { OfflineConfigSettings } from "../../services/offline-data-service/OfflineDataService";


import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseOfflineConfigQueryParameters = {
} & BaseUseQueryParameters<OfflineConfigSettings>

export function useOfflineConfig(params: UseOfflineConfigQueryParameters) {
    return useQuery<OfflineConfigSettings, RestError>(
        keys.configuration(),
        ({ signal }) => {
            return OfflineDataService.getOfflineConfig();
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
        }
    );
}
